// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rGBJ","question":"styles_question__1Aoin","inputVisibleButton":"styles_inputVisibleButton__ta9MK","note":"styles_note__1HM11"};